import React, { useEffect } from "react";
import { View } from "react-native";
import { registerTvKeys } from "../tvFocus";
import { RootNavigator } from "../navigation/RootNavigator";

const App = () => {
  useEffect(() => {
    registerTvKeys();
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <RootNavigator />
    </View>
  );
};

export default App;
